export function ToUnreceivedCheque(_UnreceivedCheque: any) {
  const unreceivedCheque = {
    countCheque: 0,
    chequeTotal: 0.0,
  };
  if (_UnreceivedCheque !== null) {
    unreceivedCheque.countCheque = _UnreceivedCheque.countCheque;
    unreceivedCheque.chequeTotal = _UnreceivedCheque.chequeTotal;
    return unreceivedCheque;
  }
  return unreceivedCheque;
}

export function ToBankAccountList(_bankAccountList: any) {
  const bankAccountList = [] as any;
  if (_bankAccountList !== null) {
    for (let i = 0; i < _bankAccountList.length; i++) {
      const bankAccountData = {
        id: _bankAccountList[i].id,
        merchantId: _bankAccountList[i].merchantId,
        name: _bankAccountList[i].name,
        bankName: _bankAccountList[i].bankName,
        bankNumber: _bankAccountList[i].bankNumber,
        description: _bankAccountList[i].description,
        bankAccountType: _bankAccountList[i].bankAccountType,
        branchName: _bankAccountList[i].branchName,
        bankShortName: _bankAccountList[i].bankShortName,
        bankRefTypeId: _bankAccountList[i].bankRefTypeId,
        isCashIn: _bankAccountList[i].isCashIn,
        isCashOut: _bankAccountList[i].isCashOut,
        startAmount: _bankAccountList[i].startAmount,
        haveCheque: _bankAccountList[i].haveCheque,
        bankType: _bankAccountList[i].bankType,
        code: _bankAccountList[i].code,
        urlBankLogo: _bankAccountList[i].urlBankLogo,
        fullName: _bankAccountList[i].fullName,
        status: "null",
      };
      bankAccountList.push(bankAccountData);
    }
  }

  return bankAccountList;
}

export function ToFinanceMonitoringList(_financeMonitoringList: any) {
  const financeMonitoringList = [] as any;
  if (_financeMonitoringList.length > 0) {
    _financeMonitoringList.forEach((item: any) => {
      const financeMonitoringData = {
        bankAccountId: item.bankAccountId,
        name: item.name,
        fullName: item.fullName,
        urlBankLogo: item.urlBankLogo,
        total: item.total,
        changeFormType: item.changeFormType,
        changeFormValue: item.changeFormValue,
        bankAccountType: item.bankAccountType,
        branchName: item.branchName,
        bankNumber: item.bankNumber,
        bankName: item.bankName,
        bankType: item.bankType,
        bankRefTypeId: item.bankRefTypeId,
        bankShortName: item.bankShortName,
        code: item.code,
      };
      financeMonitoringList.push(financeMonitoringData);
    });
  }
  return financeMonitoringList;
}
